export default __webpack_public_path__ + "static/media/partners.2ebe2f48.png";